import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./style.scss";
import classNames from "classnames";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import TabMenu from "../../react-components/tab-menu";
import LevelSummaryDetails from "../../sections/comparison-tool-level-summary";
import api from "../../utils/api";
import { MathUtils } from "../../utils";
const routePattern = "/l/";
const ComparisonTool = props => {
  const { rendering, fields, lang, history } = props,
    { paddingTop = { fields: { phrase: { value: "default" } } }, paddingBottom = { fields: { phrase: { value: "default" } } }, backgroundColor, headingType, headingBody, body, tabs } = fields;

  const [route, setRoute] = useState(
    props.match.params.param_1
      ? {
          param_1: props.match.params.param_1
        }
      : {}
  );
  if (route.param_1) props.match.params.param_1 = route.param_1;
  else delete props.match.params.param_1;
  const [tabMenuItems, setTabMenuItems] = useState(Array.isArray(tabMenuItems) ? tabMenuItems : []);
  const [country, setCountry] = useState(lang.indexOf("-") > -1 ? lang.split("-")[1] : "nl");

  const currentRouteTabIndex = tabMenuItems.length ? (props.match.params.param_1 ? tabMenuItems.findIndex(item => item.path === props.match.params.param_1) : 0) : 0;

  const getData = async () => {
    let memberShipList = await getMembershipLevelPriceAll();
    let level2Price = await getLevel2MinPrice();
    setTabMenuItems(
      tabs.map((item, index) => {
        let code = item.fields && item.fields.memberShipCode && item.fields.memberShipCode.fields && item.fields.memberShipCode.fields.phrase && item.fields.memberShipCode.fields.phrase.value;
        let price = MathUtils.priceFormat(0, lang);
        let membership = memberShipList.filter(x => x.membershipCode === code)[0];
        let spus = membership.spuList;
        if (spus && spus.length) {
          price = spus[0].lowestPrice;
          price = MathUtils.priceFormat(price, lang);
        }
        // from ALD
        if (item.fields.path.value === "level-2") {
          price = MathUtils.priceFormat(Math.abs(level2Price), lang);
        }
        // from Santander
        // if (item.fields.path.value === "level-3") {
        //   price = MathUtils.priceFormat(Math.abs(level2Price), lang);
        // }
        if (item.fields.price.value) {
          price = item.fields.price.value;
        }
        return {
          label: membership.membershipName,
          path: item.fields.path.value,
          data: {
            isHidePrice: item.fields.isHidePrice.value,
            currency: item.fields.pricePrefix.value,
            price: `${price}${item.fields.priceSuffix.value}`
          }
        };
      })
    );
  };

  const comparisonToolClassNames = classNames("comparison-tool", "grid", paddingBottom ? `padding-bottom-${paddingBottom.fields.phrase.value}` : undefined, paddingTop ? `padding-top-${paddingTop.fields.phrase.value}` : undefined);
  const backgroundStyle = {
    background: backgroundColor ? backgroundColor.fields.phrase.value : "transparent"
  };
  const getMembershipLevelPriceAll = async () => {
    let result = await api.memebership.list();
    return result.obj;
  };
  const getLevel2MinPrice = async () => {
    let prices = [];
    let result = await api.ald.products({ country });
    if (result && result.data) {
      result.data.forEach(item => {
        item.pricings &&
          item.pricings.forEach(x => {
            prices.push(x.monthFee);
          });
      });
    }
    return Math.min(...prices);
  };

  const clickCalculation = link => {
    if (link?.value?.href) {
      let href = link?.value?.href;
      if (href.indexOf("?") > -1) {
        let replaceHref = href.split("?")[0];
        replaceHref += `/l/${props.match.params.param_1}`;
        history.push(replaceHref);
      } else {
        href += `/l/${props.match.params.param_1}`;
        history.push(href);
      }
    }
  };
  const setRouteFromWindowLocation = () => {
    const params = {
      param_1: window.location.href && window.location.href.split(routePattern).length > 1 ? window.location.href.split(routePattern)[1] : undefined
    };
    setRoute(params);
  };

  useEffect(() => {
    getData();
    window.addEventListener("popstate", setRouteFromWindowLocation);
    return () => window.removeEventListener("onpopstate", setRouteFromWindowLocation);
  }, []);

  useEffect(() => {

  }, []);

  useEffect(() => {
    if (route.param_1) {
      window.history.pushState(null, null, `/${props.match.params.lang}/${props.match.params.sitecoreRoute.replace(/^\//, "")}/l/${route.param_1}`);
      props.match.params = {
        ...props.match.params,
        param_1: route.param_1
      };
    }
  }, [route]);

  return (
    <div datasourceid={rendering.dataSource} className={comparisonToolClassNames} style={backgroundStyle}>
      <Heading typographyClass="type-h1" type={headingType} html={headingBody} className="title" />

      <BodyText html={body.value} />
      <TabMenu
        tabMenu={{ items: tabMenuItems }}
        selectedTabIndex={currentRouteTabIndex}
        match={props.match}
        onTabClicked={(event, tab, option) => {
          tab.path &&
            setRoute({
              param_1: tab.path
            });
        }}
      />
      {tabs[currentRouteTabIndex] && (
        <>
          <div className="level-summary-info">
            <Heading
              {...{
                typographyClass: "type-h2",
                html: tabs[currentRouteTabIndex].fields.headingBody,
                type: tabs[currentRouteTabIndex].fields.headingType,
                className: "title"
              }}
            />
            <BodyText html={tabs[currentRouteTabIndex].fields.body.value} />
          </div>
          <LevelSummaryDetails
            {...{
              details: tabs[currentRouteTabIndex].fields.details,
              detailsLabel: tabs[currentRouteTabIndex].fields.detailsLabel.value,
              cta: {
                ...tabs[currentRouteTabIndex].fields.cta?.fields,
                callback: () => clickCalculation(tabs[currentRouteTabIndex].fields.cta?.fields?.link)
              },
              allDetailsLink: {
                text: tabs[currentRouteTabIndex].fields.buttonText?.value,
                href: tabs[currentRouteTabIndex].fields.destination?.value.href,
                linktype: tabs[currentRouteTabIndex].fields.destination?.value.linktype
              },
              currency: tabMenuItems[currentRouteTabIndex]?.data.currency,
              isHidePrice: tabMenuItems[currentRouteTabIndex]?.data.isHidePrice,
              price: tabMenuItems[currentRouteTabIndex]?.data.price
            }}
          />
        </>
      )}

      {tabs[currentRouteTabIndex].fields.image && (
        <div
          className="image"
          style={{
            backgroundImage: `url(${tabs[currentRouteTabIndex].fields.image.value.src})`
          }}
        />
      )}
    </div>
  );
};

ComparisonTool.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    paddingTop: PropTypes.object,
    paddingBottom: PropTypes.object,
    backgroundColor: PropTypes.object,
    headingType: PropTypes.object,
    headingBody: PropTypes.shape({ value: PropTypes.string }),
    body: PropTypes.shape({ value: PropTypes.string }),
    tabs: PropTypes.arrayOf(PropTypes.object)
  })
};

export default withRouter(ComparisonTool);
